import React from 'react';
import Integrations from './Integrations';

export default class IntegrationsInted extends React.Component {

    render() {



        return (
            <div className="general-setting" >
                <Integrations {...this.props} />
            </div>
        );
    }
}
